import { resolveBaseURL } from "services/api"

export const TELEGRAM_STATUS = {
  SENT: "sent",
  LINK_REQUIRED: "link_required",
  REGISTRATION_REQUIRED: "registration_required",
  NOT_ALLOWED: "not_allowed",
} as const

export type TelegramStatus = (typeof TELEGRAM_STATUS)[keyof typeof TELEGRAM_STATUS]

export type TelegramPending = {
  deepLink?: string
  isRegistration: boolean
}

export type TelegramSendCodeResult = {
  status: TelegramStatus
  deepLink?: string
  appLink?: string
}

export class TelegramLoginError extends Error {
  status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = "TelegramLoginError"
    this.status = status
  }
}

export async function sendTelegramCode(phone: string): Promise<TelegramSendCodeResult> {
  const base = resolveBaseURL().replace(/\/+$/, "")

  const res = await fetch(`${base}/auth/telegram/send-code`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ phone }),
  })

  let body: { message?: string; data?: Record<string, string> } = {}
  try {
    body = await res.json()
  } catch {
    body = {}
  }

  if (!res.ok) {
    throw new TelegramLoginError(body?.message || "Telegram bilan bog'lanib bo'lmadi", res.status)
  }

  const data = body?.data ?? {}

  return {
    status: data.status as TelegramStatus,
    deepLink: data.deep_link,
    appLink: data.app_link,
  }
}
